import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import axios from 'axios';
import { apiUrl, mediaUrl, woundlistURL,specialistURL} from'../Config/Config';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import { GET_VIEWCATEGORYLIST } from '../../actions';
import parser from 'html-react-parser';
import './View.css'; // optional for styling
// import 'bootstrap/dist/css/bootstrap.min.css';

class View extends Component {
  
  constructor(props)
  {
    super(props); 
    const categoryid = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

    this.state = {      
      categoryid: categoryid,
      woundlistdata:'',
      productCategory:'',
       showModal: false,
      selectedImage: '',
      zoomed: false,
    };

    var qs = require('qs');
    var postObject = {             
    id   :categoryid
    };

    axios.post(apiUrl+"woundtypelist/view",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){
        console.log( res.data.product_category)
          this.setState({ woundlistdata: res.data.woundlistdata});
          // this.setState({ productCategory: res.data.product_category[0]});

      }
    }); 
  }

   componentDidMount() {
     document.title = PageTitle('Category View');
   }

    handleImageClick = (img) => {
   
    this.setState({
      selectedImage: mediaUrl + '/' + img,
      showModal: true,
      zoomed: false,
    });
  };

  handleClose = () => {
    this.setState({ showModal: false, zoomed: false });
  };

  toggleZoom = () => {
    this.setState((prevState) => ({ zoomed: !prevState.zoomed }));
  }
  render() {
     const { showModal, selectedImage, zoomed } = this.state;
  if(this.state.woundlistdata!==undefined){
    var woundlistdata = this.state.woundlistdata;
  }
  let loaderimg = '';
  let preview = '';

if (woundlistdata && woundlistdata.images && woundlistdata.images.length > 0) {
  preview = woundlistdata.images.map((img, index) => {
    const imageURL = mediaUrl + '/' + img;
    return (
      <img
        key={index}
        className="img_class"
        src={imageURL}
        alt={`Wound ${index + 1}`}
        style={{ width: '100px', cursor:'pointer', height: '100px', marginRight: '10px' }}
        onClick={() => this.handleImageClick(img)}
      />
    );
  });
} else {
  preview = (
    <img
      className="img_class"
      src={woundlistURL + '/default.png'}
      alt="No Image"
    />
  );
}


    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="woundtypelist" />  
      
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
            <div className="content-body">
               <div className="form-wrapper leaa-admin-head card">
               <div>
                  <a className="cursor-pointer btn-arrow" href="/woundtypelist">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg>
                  </a>
                  </div>
                <div className="title">
                  <h3>Wound Care Type</h3>
                </div>
                <div className="form-row">
                  <div className="details_left">
                      <div className="view-details">
                        <div className="view-details-one">
                            <p><b>Name<span>:</span> </b></p>
                        </div>
                        <div className="view-details-two">
                            <p>{woundlistdata.cat_name}</p>
                        </div>
                      </div>
                      <div className="view-details">
                        <div className="view-details-one">
                            <p><b>Stage<span>:</span> </b></p>
                        </div>
                        <div className="view-details-two">
                            <p>{woundlistdata.stage}</p>
                        </div>
                      </div>
                     
                   

                    

                     


                      {woundlistdata.description!=''&&woundlistdata.description!=undefined&&
                      <div className="view-details">
                        <div className="view-details-one">
                            <p><b>Description<span>:</span> </b></p>
                        </div>
                        <div className="view-details-two">
                            <p>{parser(woundlistdata.description)}</p>
                        </div>
                      </div>}
                      {woundlistdata.recommendations_description!=''&&woundlistdata.recommendations_description!=undefined&&
                       <div className="view-details">
                        <div className="view-details-one">
                            <p><b>Recommendations<span>:</span> </b></p>
                        </div>
                        <div className="view-details-two">
                            <p>{parser(woundlistdata.recommendations_description)}</p>
                        </div>
                      </div>}
                      

                        <div className="view-details">
                        <div className="view-details-one">
                            <p><b> Status<span>:</span> </b></p>
                        </div>
                        <div className="view-details-two">
                            <p>{(woundlistdata.status=='A')?'Active':'Inactive'}</p>
                        </div>
                      </div>
                      <div className="view-details">
                        <div className="view-details-one">
                            <p><b>Wound Care Images<span>:</span> </b></p>
                        </div>
                        <div className="view-details-two">
                          {preview}
                        </div>
                        {showModal && (
                            <div className="custom-modal">
                              <div className="modal-content">
                                <span className="close-btn" onClick={this.handleClose}>
                                  &times;
                                </span>
                                <img
                                  src={selectedImage}
                                  alt="Zoom"
                                  className={zoomed ? 'zoomed' : ''}
                                  onClick={this.toggleZoom}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                    

                      </div>
                      </div>
               
                    
                     
                    
                    <div className="map-wrapper">                      
                     <div id="map"></div>
                     <div className="mapbox-gl-marker"></div>
                    </div>
              </div>            
            
          </div>
         </div> 
        </div>        
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    categorylistview: state.categorylistview
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getViewCategoryList: (categoryid) =>{
       dispatch({ type: GET_VIEWCATEGORYLIST,categoryid });
    },
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(View));